export const LAST_EXPORT_COOKIE_NAME = 'lastexport';
export const EXPORT_STAGES = {
  PREPARING: 0,
  EXPORTING: 1,
  COMPRESSING: 2,
  SUCCESS: 3,
};
export const SUCCESS_DATE_FORMAT = 'MM/DD/yyyy';
